module.exports = __webpack_public_path__ + "img/isalogo.4f62ed81.png";